<main
  class="main"
  style="background-color: #efecea; color: black; max-width: 500px; padding: 20px"
>
  <mat-dialog-content>
    <p [innerHTML]="'requestCarWarning' | i18next"></p>
  </mat-dialog-content>
  <mat-dialog-actions style="justify-content: center">
    <div class="d-flex justify-content-center align-items-center mb-3 gap-4">
      <button class="btn-yes" type="button" (click)="onModalResponse(false)">
        {{ 'requestCarWarningCancel' | i18next }}
      </button>
      <button class="btn-no" type="button" (click)="onModalResponse(true)">
        {{ 'requestCarWarningConfirm' | i18next }}
      </button>
    </div>
  </mat-dialog-actions>
</main>
